import { render, staticRenderFns } from "./ChatRoomList.vue?vue&type=template&id=b54fae74&scoped=true"
import script from "./ChatRoomList.vue?vue&type=script&lang=js"
export * from "./ChatRoomList.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomList.vue?vue&type=style&index=0&id=b54fae74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54fae74",
  null
  
)

export default component.exports